
import { defineComponent } from 'vue';
import useCapabilities from '@/resources/capabilities';
import api from '@/api';
import withTimeout from '@/resources/timeOut';
// eslint-disable-next-line import/no-cycle
import { filtersToQueryParameters, setQueryParameters } from '@/helpers/Url';
import VTable from '@/components/vendor/basic/table/VTable.vue';
import VTableHeader from '@/components/vendor/basic/table/VTableHeader.vue';
import VTableBody from '@/components/vendor/basic/table/VTableBody.vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VInput from '@/components/vendor/basic/form/parts/VInput.vue';
import Clinic from '@/api/objects/Clinic';
import TheAdminClinicShow from '@/views/administrator/clinic/TheAdminClinicShow.vue';
import TheAdminClinicEdit from '@/views/administrator/clinic/TheAdminClinicEdit.vue';
import VPagination from '@/components/vendor/VPagination.vue';

export default defineComponent({
  name: 'TheProfessionalExpedientsList',
  components: {
    VPagination,
    TheAdminClinicEdit,
    TheAdminClinicShow,
    VInput,
    VButton,
    VTableBody,
    VTableHeader,
    VTable,
  },
  data() {
    return {
      clinics: [] as Clinic[],
      clinicsPagination: null as any,
      selectedClinic: null,
      modalToShow: '' as string,
      filters: {
        search: [] as any,
      },
      do_search: true,
      timers: {
        search: '',
      },
    };
  },
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  async mounted() {
    await this.setQueryParametersAsFilters();
    await this.doSearch();
  },
  methods: {
    openClinicShowModal(clinic) {
      this.selectedClinic = clinic;
      this.modalToShow = 'the-admin-clinic-show';
    },
    openClinicEditModal(clinic) {
      this.selectedClinic = clinic;
      this.modalToShow = 'the-admin-clinic-edit';
    },
    search() {
      this.timers.search = withTimeout(async () => {
        await this.doSearch();
      }, this.timers.search, 250);
    },
    /**
     * Sets the local filters as url query parameters.
     */
    setFiltersAsQueryParameters() {
      setQueryParameters('admin.clinic.index', this.filters);
    },
    /**
     * Detects any query parameter in the url and loads it in the filters (if available)
     *
     * @returns {Promise<void>}
     */
    async setQueryParametersAsFilters() {
      const queryParameters = this.$route.query;

      if (queryParameters.search) {
        this.filters.search = queryParameters.search;
      } else {
        this.filters.search = '';
      }
    },
    async loadClinics(page?: number) {
      try {
        const filters = { ...this.filters } as any;

        // We manage page filter if provided
        if (!!page) {
          filters.page = page;
        }

        const query = filtersToQueryParameters(filters);

        const resp = await api.admin.clinic.all(query, true);

        if (!!resp.meta) {
          this.clinics = resp.data;
          this.clinicsPagination = {
            meta: resp.meta,
            pagination: resp.links,
          };
        } else {
          this.clinics = resp;
        }
      } catch (e) {
        this.$toast.error(this.$t('Ha ocurrido un error al cargar las clínicas'));
      }
    },
    async doSearch() {
      this.do_search = false;
      await this.setFiltersAsQueryParameters();
      await this.loadClinics();
    },
    async handlePageChangedEvent(page) {
      // We handle page only on the method call to avoid malfunctioning with page filter
      await this.loadClinics(page);
    },
    emptyFilters() {
      this.filters = {
        search: '',
      };

      this.doSearch();
    },
  },
});
